const filterByName = () => (items, props) =>
  props
    ? items.filter((el) => el.name.toLowerCase().includes(props.toLowerCase()))
    : items

angular.module('ccs').filter('filterByName', filterByName)
